<template>
    <div class="root">
        <TableBlock ref="tableData" :columns="cloumn" :action="action" :param="param" :navHeight="260">
            <div class="common-space-between">
                <div class="common-items-center">
                    <InputBlock title="账户类型" :width="150">
                        <el-select v-model="param.belongToType" placeholder="请选择账户类型" @change="selectBtn" :size="this.$store.state.btnSize">
                            <el-option v-for="item in this.$store.state.conText.accountTypeList" :key="item.val" :label="item.title" :value="item.val" />
                        </el-select>
                    </InputBlock>
                    <InputBlock title="账户信息" :showBlock="false" :width="150">
                        <!-- <el-input v-model="param.belongToId" :size="this.$store.state.btnSize" placeholder="请输入账号"></el-input> -->
                        <el-select :disabled="!param.belongToType" :size="this.$store.state.btnSize"  v-model="param.belongToId" filterable placeholder="请选择">
                            <el-option
                            v-for="item in receiverList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </InputBlock>
                    <Month title="创建时间" ref="mouth" :width="150" @getDate="getDate"></Month>
                    <el-button class="btn-heigth" type="primary" icon="el-icon-search" :size="this.$store.state.btnSize"   @click="searchBtn">搜索</el-button>
                    <el-button class="btn-heigth" type="danger"  icon="el-icon-refresh" :size="this.$store.state.btnSize"  @click="resetBtn">重置</el-button>
                </div>
                <div>
                    <el-button class="btn-heigth" type="primary" icon="el-icon-download" :size="this.$store.state.btnSize"   @click="exportBtn">导出</el-button>
                </div>
            </div>
        </TableBlock>
        <TopUp ref="TopUp" :listData="listData" @resetBtn="searchBtn" ></TopUp>
    </div>
</template>
<script>
import {api,operate } from '@/utils/config'
import { columns } from './index.js'
import { exportFun,getFun } from '@/utils/httpFun'
import Month from '@/components/component-block/block-month.vue'
import TopUp from './../recharge/module-block/TopUp.vue'
export default {
    components: {
        Month:Month,
        TopUp:TopUp
    },
    data() {
        return {
            cloumn: [],
            listData:{},
            action: operate.GETPAGEACCOUNT,
            receiverList:[],
            param: {
                belongToType:2,
                belongToId:null,
                startTime:null,
                endTime:null
            }
        };
    },
    created() {
        this.cloumn = columns(this);
    },
    mounted() {
        this.getReceiverFun();
    },
    methods: {
        getReceiverFun(index = 2){
            getFun(operate.GETPLATFORMUSER+'/'+index,{},res=>{
                console.log('======',res.data);
                this.receiverList = res.data;
            })
        },
        searchBtn(){
           this.$refs.tableData.getDatas()
        },
        resetBtn(){
            this.param.belongToId=""
            this.param.startTime=""
            this.param.endTime=""
            this.$refs.mouth.clear()
            this.$refs.tableData.resetHttp()  
        },
        selectBtn(ev){
            this.param.belongToType = ev
            this.getReceiverFun(ev);
            this.resetBtn()
        },
        //获取时间
        getDate(ev) {
            this.param.startTime = ev.startDate
            this.param.endTime = ev.endDate
        },
       
        //充值
        rechargeBtn(ev){
            this.$refs.TopUp.openBtn(ev)
        },

        //详情 
        lookBtn(ev){
          this.$router.replace({
            path:"RechargeDetail",
            query:{
                belongToId:ev.belongToId,
                belongToType:ev.belongToType  
            }
          })
        },
       
        //导出
        exportBtn(){
            exportFun(api.Operate+"/financeManager/exportAccountRechargeRecord",this.param,"账户充值管理")
        }
    }
}
</script>
  
<style lang="scss" scoped></style>